<template>
    <div>
        <template v-if="hasExpression">
            <edit-formula-expression
                v-bind:data-test-role="testRole"
                v-bind:expression="childBinder.expression"
                v-bind:path="childBinder.path" />
        </template>
        <template v-else>
            <pc-interact
                v-bind:is-dropzone="true"
                v-bind:data-test-role="testRole"
                v-on:dropzone-drag-enter="dropzoneEnter"
                v-on:dropzone-drag-leave="dropzoneLeave"
                v-on:dropzone-drop="dropFormula">
                <span
                    class="d-inline-block align-items-center operand align-middle"
                    v-bind:class="[operandClass, droppedClass, dropzoneClass]" />
            </pc-interact>
        </template>
    </div>
</template>
<script>
    import { getClassSuffix } from "Formula/metadata";
    export default {
        name: "EditChildFormulaExpression",
        inject: ["formulaControl"],
        props: {
            childBinder: { type: Object, required: true }
        },
        data() {
            return {
                dropzone: {
                    active: false
                }
            };
        },
        computed: {
            hasExpression() {
                return this.childBinder.expression != null;
            },
            operandClass() {
                return this.childBinder.operandType != null
                    ? "operand-" + getClassSuffix(this.childBinder.operandType)
                    : "";
            },
            isDroppable() {
                // For empty root all can be dropped except dynamic formula with no result type
                const canDropInEmptyRoot =
                    this.$root.isPathRoot(this.childBinder.path) && !this.$root.dragDynamicFormulaHasNoResultType;

                // For not empty root , drop dynamic formula with no result type
                // or coalesce formula with no result type or when operand type matches
                const canDropInEmptyChild =
                    !this.$root.isPathRoot(this.childBinder.path) &&
                    (this.$root.dragCoalesceMultiInstanceValueHasNoResultType ||
                        this.$root.dragDynamicFormulaHasNoResultType ||
                        this.$root.dragResultType === this.childBinder.operandType);

                //Don't allow dropping in empty childern of Dragged Node
                return (
                    this.formulaControl.isDroppable &&
                    (canDropInEmptyRoot || canDropInEmptyChild) &&
                    !this.isSubarray(this.childBinder.path, [...this.$root.dragPath])
                );
            },
            droppedClass() {
                return this.isDroppable ? "droppable" : "";
            },
            dropzoneClass() {
                return { dropzone: this.dropzone.active };
            },
            testRole() {
                return !this.formulaControl.isClone && this.formulaControl.inEditMode
                    ? "editorFormula" + this.childBinder.path.toString()
                    : "";
            }
        },
        methods: {
            dropzoneEnter() {
                this.dropzone.active = this.isDroppable;
            },
            dropzoneLeave() {
                this.dropzone.active = false;
            },
            dropFormula() {
                if (this.dropzone.active) {
                    this.$root.dropChildFormula(this.childBinder.operandType, [...this.childBinder.path]);
                }
                this.dropzone.active = false;
            },
            isSubarray(main, sub) {
                if (main.length < sub.length || sub.length === 0) {
                    return false;
                }
                for (let i = 0; i < sub.length; i++) {
                    if (sub[i] != main[i]) {
                        return false;
                    }
                }
                return true;
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "Formula/Components/_formula-style-vars.scss";

    .operand {
        min-width: $operand-width;
        min-height: $operand-width;
        border-radius: $formula-borderRadius;
        background-color: $operand-root-color;
        border: 0.25rem dashed transparent;
    }
    .operand-numeric {
        border-radius: $formula-borderRadius-empty;
        background-color: $numeric-color;
    }
    .operand-boolean {
        border-radius: $formula-borderRadius-empty;
        background-color: $boolean-color;
    }
    .operand-string {
        border-radius: $formula-borderRadius-empty;
        background-color: $string-color;
    }
    .operand-date {
        border-radius: $formula-borderRadius-empty;
        background-color: $date-color;
    }
    .droppable {
        background-color: $operand-droppable-color;
        border-color: $operand-droppable-border-color;
        border: 0.25rem dashed $operand-droppable-border-color;
    }
    .dropzone {
        background-color: $operand-dropzone-color;
        border: 0.25rem dashed $operand-dropzone-border-color;
    }
</style>
